import React from "react";
import "./pages.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/esm/Row";
import CarouselProduct from "../Components/Carousel";
import Banner from "../Components/Header/Banner";
import { Button } from "react-bootstrap";
import Images from "../Components/Images";
import Recommends from "../Components/Recommends";

function Home() {
  return (
    <div className="home">
      {/* {modalBox ? <ModalBox close={close} /> : <div></div>} */}
      <Banner
        url={
          "url(/images/4a2a004a8e908f42dbbfad724178abbe44fec273.webp)"
        }
      // url={
      //   "url(https://i.imagesup.co/images2/4d329271b61f0e5ad2f5ca116e2e8c60d868ac9d.png)"
      // }
      ></Banner>
      <h3 className="des-top"></h3>
      <div>
        <div className="body-carosel">
          <CarouselProduct></CarouselProduct>
        </div>
      </div>
      <Row className="card-about">
        <Col style={{ paddingRight: "0%", paddingLeft: "0%" }}>
          <img
            className="image-about"
            alt="img-about"
            src={
              "/images/noatalel.webp"
            }
            style={{
              height: "100%",
              width: "100%",
            }}
          />
        </Col>
        <Col className="text-about">
          <h3 className="title">MY STORY</h3>
          <div className="about-content">
            <p className="about-intro">
              היי, אני <strong>נועה טל-אל</strong>, נעים להכיר.<br />
              מאז שאני זוכרת את עצמי, אני חיה ונושמת את עולם הקוסמטיקה.
            </p>
            <div className="about-details">
              <p>
                למדתי אצל חוה זינגבוים במשך שנה וחצי, ולאחר מכן השלמתי שפע של
                קורסים והשתלמויות. עולם הקוסמטיקה מרגש ומעניין אותי, ואני
                תמיד שואפת ללמוד ולהביא טכנולוגיות וחידושים.
              </p>
              <p>
                אני אוהבת להרגיש מטופחת, ועוד יותר אוהבת לגרום ללקוחות שלי להרגיש
                בשיא שלהם. כל מטופל/ת שנכנסים אליי לקליניקה הם <em>עולם ומלואו</em>.
              </p>
              <div className="about-highlight">
                אני מזמינה אתכם לקליניקה שלי בהוד השרון למגוון טיפולים מקצועיים, המשלבים
                מכשור מתקדם ותכשירים איכותיים של החברות המובילות בשוק.
              </div>
            </div>
            <div className="read-more">
              <Button variant="outline-dark" href="/Contact" className="modern-btn">
                צור קשר
              </Button>
            </div>
          </div>
        </Col>
      </Row>

      <div style={{ marginBottom: "10%" }}>
        <Row className="card-service">
          <Col style={{ paddingRight: "0%", paddingLeft: "0%" }}>
            <img
              className="image-service"
              alt="img"
              src="/images/d34f67507fbd1f2185bfe92e8e9d358080f923e1.webp"
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </Col>
          <Col className="text-service">
            <h3 className="title">TYPES OF GLOW</h3>
            <div className="service-intro">
              <strong>כל טיפול מתחיל באבחון מדוייק של העור, סוג העור והמצב שלו.</strong>
            </div>
            <div className="treatment-list">
              <div className="treatment-item-modern">
                <span className="treatment-name">טיפול קלאסי</span>
                <span className="treatment-divider">-</span>
                <span className="treatment-description">משלב בתוכו ניקוי עמוק של העור, פילינגים, לחויות, מסכות ועיסויי עור הפנים.</span>
              </div>
              <div className="treatment-item-modern">
                <span className="treatment-name">טיפול אקנה</span>
                <span className="treatment-divider">-</span>
                <span className="treatment-description">לאחר אבחון העור והבנה לסיבות הפצעונים, נטפל בשורש הבעיה. הטיפול משלב פילינגים, מסכות וניקוי עמוק.</span>
              </div>
              <div className="treatment-item-modern">
                <span className="treatment-name">טיפול פיגמנטציה</span>
                <span className="treatment-divider">-</span>
                <span className="treatment-description">שילוב מגוון פילינגים, חומצות, מסכות ומכשור מתקדם כדי להבהיר כתמי עור בהתאמה אישית.</span>
              </div>
              <div className="treatment-item-modern">
                <span className="treatment-name">טיפול אלקטרופורציה</span>
                <span className="treatment-divider">-</span>
                <span className="treatment-description">טכנולוגיה מתקדמת לשיקום ומיצוק העור, טיפול בקמטוטי הבעה, הדגשת קו לסת והבהרה.</span>
              </div>
              <div className="treatment-item-modern">
                <span className="treatment-name">טיפול מזותרפיה</span>
                <span className="treatment-divider">-</span>
                <span className="treatment-description">פציעה מבוקרת כאנטי אייג'ינג לטשטוש צלקות וקמטים, יעיל גם מול כתמי עור.</span>
              </div>
              <div className="treatment-item-modern">
                <span className="treatment-name">טיפול החדרת לחויות</span>
                <span className="treatment-divider">-</span>
                <span className="treatment-description">טיפול פינוק שמשלב לחויות ועיסויים, למראה עור חי, זוהר ובשיא שלו.</span>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <h1 className="title">customers recommend</h1>
      <Recommends></Recommends>
      <h3 className="title">FOLLOW US</h3>
      <Images></Images>
    </div>
  );
}

export default Home;
